import { render, staticRenderFns } from "./KBlackScreen.vue?vue&type=template&id=1b2bc372&scoped=true&"
import script from "./KBlackScreen.vue?vue&type=script&lang=js&"
export * from "./KBlackScreen.vue?vue&type=script&lang=js&"
import style0 from "./KBlackScreen.vue?vue&type=style&index=0&id=1b2bc372&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2bc372",
  null
  
)

export default component.exports